module.exports = __webpack_public_path__ + "img/what-is-lego-universe.e95bea2b.jpg";